import { useState, type FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@crashx/ui";
import { chatApi, chatError } from "./chatApi.js";
import { useChatStore } from "./chatStore.js";

export function ChatComposer({ disabled, maxLength }: { disabled: boolean; maxLength: number }) {
  const { t } = useTranslation();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function submit(event: FormEvent) {
    event.preventDefault();
    if (disabled || busy || !text.trim()) return;
    const epoch = useChatStore.getState().epoch;
    setBusy(true);
    setError(null);
    try {
      const message = await chatApi.send(text);
      if (epoch !== useChatStore.getState().epoch) return;
      useChatStore.getState().message(message);
      setText("");
    } catch (cause) {
      setError(chatError(cause));
    } finally {
      setBusy(false);
    }
  }
  return (
    <form onSubmit={(event) => void submit(event)} className="flex flex-col gap-2">
      <label className="cx-field">
        {t("chat.message")}
        <input
          className="cx-input"
          value={text}
          maxLength={maxLength}
          disabled={disabled || busy}
          aria-describedby="chat-counter"
          onChange={(event) => setText(event.target.value)}
        />
      </label>
      <span id="chat-counter" className="text-xs text-muted">
        {t("chat.counter", { count: text.length, max: maxLength })}
      </span>
      {error ? (
        <p role="alert" className="text-danger">
          {t(error)}
        </p>
      ) : null}
      <Button type="submit" disabled={disabled || busy || !text.trim()}>
        {t("chat.send")}
      </Button>
    </form>
  );
}
